<template>
  <div>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="margin-top: 10px;"
      :rules="rules"
      ref="ruleForm"
    >
      <a-form-model-item label="Khách hàng" prop="name">
        <a-input v-model="form.name" placeholder="Nhập khách hàng..." />
      </a-form-model-item>
      <a-form-model-item label="Mã" prop="code">
        <a-input v-model="form.code" placeholder="Enter text" />
      </a-form-model-item>
      <a-form-model-item label="End User Class" prop="endUserClass">
        <a-input v-model="form.endUserClass" placeholder="Enter text" />
      </a-form-model-item>
      <a-form-model-item label="Địa chỉ" prop="address">
        <a-textarea
          rows="3"
          v-model="form.address"
          placeholder="Nhập địa chỉ..."
        />
      </a-form-model-item>
      <a-form-model-item label="Mã thuế">
        <a-input v-model="form.taxCode" placeholder="Nhập mã thuế..." />
      </a-form-model-item>
      <a-form-model-item label="Tài khoản ngân hàng">
        <a-input
          v-model="form.accountBank"
          placeholder="Nhập tài khoản ngân hàng..."
        />
      </a-form-model-item>
      <a-form-model-item label="Điện thoại" prop="tel">
        <a-input v-model="form.tel" placeholder="Nhập điện thoại..." />
      </a-form-model-item>
      <a-form-model-item label="Người đại diện">
        <a-input
          v-model="form.representedBy"
          placeholder="Nhập tên người đại diện..."
        />
      </a-form-model-item>
      <a-form-model-item label="Chức vụ">
        <a-input
          v-model="form.positionRepresentedBy"
          placeholder="Nhập chức vụ của người đại diện..."
        />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Đóng
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading">
        Thêm mới
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../constant/query";

const rules = {
  name: [{ required: true, message: "Tên khách hàng không được bỏ trống" }],
};
export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      loading: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreatedCustomer();
        } else {
          return false;
        }
      });
    },
    onCreatedCustomer() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.createCustomer,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Thêm khách hàng thành công!",
          });
          this.loading = false;
          this.form = {};
          if (data?.createCustomer?.id) {
            this.refreshAfterCreated(data.createCustomer);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Thêm khách hàng không thành công!",
          });
          console.log("Thêm khách hàng không thành công", err);
        });
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
